export default "<div>{{ GetRapportIncidentType(id) }}</div>";